export default "__VITE_ASSET__BCFtffUe__"